module.exports = __webpack_public_path__ + "img/ee104b8.jpg";